import { render, staticRenderFns } from "./Facturacion-serviciasadminconsulta.vue?vue&type=template&id=463187b2&"
import script from "./Facturacion-serviciasadminconsulta.vue?vue&type=script&lang=js&"
export * from "./Facturacion-serviciasadminconsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports